const radius = "5%";

const styleSheet = (theme: any) => ({
  container: {
    display: "flex"
  },
  bar: {
    height: "21px",
    width: "4px",
    backgroundColor: "#BCCFE6",
    marginRight: "3px",
    borderBottomLeftRadius: radius,
    borderBottomRightRadius: radius,
    borderTopLeftRadius: radius,
    borderTopRightRadius: radius
  },
  highlighted: {
    backgroundColor: "#085FE5"
  }
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Headers/ProfileHeader/InterestBars/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/components/Headers/ProfileHeader/InterestBars/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }